module.exports = __webpack_public_path__ + "img/kfc.f57196a9.png";